import { render, staticRenderFns } from "./ChartTableSwitch.vue?vue&type=template&id=6b870d6e&"
import script from "./ChartTableSwitch.vue?vue&type=script&lang=js&"
export * from "./ChartTableSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports